import api from './api';

export interface ProductVariant {
  id: string;
  title: string;
  sku: string;
  price: string;
  inventoryQuantity: number;
}

export interface RentalProductConfig {
  shopifyProductId: string;
  title: string;
  handle: string;
  status: string;
  productType: string;
  vendor: string;
  imageUrl: string | null;
  variants: ProductVariant[];
  rentalConfig: {
    isRentalProduct: boolean;
    /** Retail weekly rate in cents */
    weeklyRateCents: number | null;
    /** Retail monthly rate in cents */
    monthlyRateCents: number | null;
    /** Retail bilateral one-time charge in cents */
    bilateralPriceCents: number | null;
    /** Wholesale weekly rate in cents (clinic orders) */
    wholesaleWeeklyRateCents: number | null;
    /** Wholesale monthly rate in cents */
    wholesaleMonthlyRateCents: number | null;
    /** Wholesale bilateral charge in cents */
    wholesaleBilateralPriceCents: number | null;
    /** Minimum rental weeks */
    minRentalWeeks: number;
  };
}

export interface UpdateRentalConfigDto {
  isRentalProduct?: boolean;
  weeklyRateCents?: number;
  monthlyRateCents?: number;
  bilateralPriceCents?: number;
  wholesaleWeeklyRateCents?: number;
  wholesaleMonthlyRateCents?: number;
  wholesaleBilateralPriceCents?: number;
  minRentalWeeks?: number;
}

export const productsApi = {
  list: async (): Promise<RentalProductConfig[]> => {
    const { data } = await api.get('/products');
    return data;
  },

  addons: async (): Promise<import('@/components/AddOnPicker').AddOnProductOption[]> => {
    const { data } = await api.get('/products/addons');
    return data;
  },

  wraps: async (): Promise<RentalProductConfig[]> => {
    const { data } = await api.get('/products/wraps');
    return data;
  },

  updateRentalConfig: async (
    productId: string,
    config: UpdateRentalConfigDto,
  ): Promise<RentalProductConfig> => {
    const encodedId = encodeURIComponent(productId);
    const { data } = await api.put(
      `/products/${encodedId}/rental-config`,
      config,
    );
    return data;
  },
};

export default productsApi;
